import type { NumberInputProps } from '@mantine/core';
import { NumberInput as MantineNumberInput, Text } from '@mantine/core';
import React from 'react';

import styles from './NumberCurrencyInput.module.css';

export const LBNumberCurrencyInput = React.forwardRef<
  React.ElementRef<typeof MantineNumberInput>,
  Omit<NumberInputProps & { currencySymbol?: string }, 'rightSection'>
>(({ currencySymbol, ...props }, ref) => (
  <MantineNumberInput
    {...props}
    ref={ref}
    classNames={styles}
    inputMode='numeric'
    inputWrapperOrder={['label', 'input', 'error', 'description']}
    rightSection={<Text>{currencySymbol ?? ''}</Text>}
    rightSectionPointerEvents='all'
  />
));
